import SyncEventsDialog from '@/components/syncevents/SyncEventsDialog';
import SyncIcon from '@mui/icons-material/Sync';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

const TreeSyncEvents: FC = () => {
  const [openManager, setOpenManager] = useState(false);

  return (
    <>
      <StyledTreeItem
        itemId='sync.events'
        label={<TreeLabel icon={SyncIcon} label='Synchronization Events' />}
        onClick={() => setOpenManager(true)}
      />
      <SyncEventsDialog open={openManager} onClose={() => setOpenManager(false)} />
    </>
  );
};

export default TreeSyncEvents;
